import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { useCongress } from '../../../congress/hooks'
import LazyImage from '../../../components/LazyImage'
import { Tooltip, Whisper } from 'rsuite'
// import moment from 'moment'
import moment from 'moment-timezone'
import 'moment-timezone';

// const momentTz = require('moment-timezone');
const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    scale: 1,
  }
}

const tooltip = (name) => (
  <Tooltip>
    {name}
  </Tooltip>
)


export default function ActivityCard ({ name, description, location, speakers, startsAt, endsAt }) {
  const { congress } = useCongress()

  let startsAtTime = moment(startsAt).tz(congress.Location).format('HH:mm');
  let endsAtTime = moment(endsAt).tz(congress.Location).format('HH:mm');

  return (
   <Container variants={itemVariants}>
     <Time color={congress.SecondaryColor}>
       {startsAtTime} - {endsAtTime}
     </Time>
     <Name>{name}</Name>
     <Description>{description}</Description>
     <Bottom>
       {speakers && (
         <Speakers>
           {speakers.map(speaker => (
              <SpeakerContainer >
                <SpeakerImage width="2.4rem" height="2.4rem" src={speaker.PhotoURL}/>
                <SpeakerName>{speaker.FirstNames} {speaker.LastNames}</SpeakerName>
             </SpeakerContainer>
           ))}
         </Speakers>
       )}
       <Location color={congress.SecondaryColor}>{location}</Location>
     </Bottom>
   </Container>
  )
}

const Container = styled(motion.div)`
  background: #FFFFFF;
  box-shadow: 0 2px 20px rgba(197, 217, 232, 0.5);
  border-radius: 12px;
  padding: 2rem 2rem 6rem;
  margin-bottom: 2rem;
  position: relative;
`

const Name = styled.h4`
  font-size: 1.6rem;
  line-height: 1.6rem;
  margin-bottom: 1rem;
`

const Description = styled.p`
  font-size: 1.5rem;
  font-weight: 300;
`

const Bottom = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  right: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const SpeakerContainer = styled.div`
  margin-right: 1.6rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const SpeakerName = styled.h4`
  font-size: 1.6rem;
  line-height: 1.6rem;
`

const Location = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${props => props.color};
`

const Speakers = styled.div`
  display: flex;
  align-items: center;
`

const SpeakerImage = styled(LazyImage)`
  border-radius: 12px;
  overflow: hidden;
  margin-right: 0.5rem;
`

const Time = styled.p`
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: ${props => props.color};
`